import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
import TextBanner from "../components/text_banner"

import client_icon from "../assets/images/client.svg"
import human_icon from "../assets/images/human.svg"
import transpersonal_icon from "../assets/images/Transpersonal.svg"
import relationships_icon from "../assets/images/relationships.svg"
import existential_icon from "../assets/images/Existential.svg"
import holistic_icon from "../assets/images/Holistic.svg"
import spiritual_icon from "../assets/images/Spiritual.svg"
import psychodynamic_icon from "../assets/images/Psychodynamic.svg"
import dept_icon from "../assets/images/Dept.svg"
import somatic_icon from "../assets/images/Somatic.svg"
import smile_icon from "../assets/images/smile.svg"
import mindfulness_icon from "../assets/images/Mindfulness.svg"
import meditation_icon from "../assets/images/Meditation.svg"
import counselling_icon from "../assets/images/Counselling.svg"
import weight_icon from "../assets/images/Weight.svg"
import eating_icon from "../assets/images/Eating.svg"
import life_icon from "../assets/images/life.svg"
import promotion_icon from "../assets/images/promotion.svg"

function Modalities() {
  return (
    <Layout>
      <Helmet>
        <title>InTouch Counselling Services - Modalities</title>
      </Helmet>

      <TextBanner
        quote="“What consumes your mind, controls your life.” – Anonymous"
      ></TextBanner>

      <section id="wrapper">
        <section id="one" className="wrapper spotlight style1 my-journey">
          <div className="inner">
            <div className="about-content">
              <h2>My Modalities & Approaches </h2>
              <p>
                I utilize a variety of modalities, the combination of which will
                be unique and depend on the needs of the client in varying a
                different phase of their therapeutic process. Each session will
                be tailored to the client’s needs and progress.
              </p>
              <p>These modalities include:</p>
              <div className="my-modalities">
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={client_icon} />
                    </div>
                    <p>Person Centered Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={human_icon} />
                    </div>
                    <p>Humanistic Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={transpersonal_icon} />
                    </div>
                    <p>Transpersonal Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={relationships_icon} />
                    </div>
                    <p>Relational Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={existential_icon} />
                    </div>
                    <p>Existential Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={holistic_icon} />
                    </div>
                    <p>Holistic Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={spiritual_icon} />
                    </div>
                    <p>Spiritual Integrated Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={psychodynamic_icon} />
                    </div>
                    <p>Psychodynamic Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={dept_icon} />
                    </div>
                    <p>Depth Integrative Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={somatic_icon} />
                    </div>
                    <p>Somatic Therapy</p>
                  </div>
                </div>

                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={smile_icon} />
                    </div>
                    <p>Emotional Freedom Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={mindfulness_icon} />
                    </div>
                    <p>Mindfulness Based Therapy</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={meditation_icon} />
                    </div>
                    <p>Meditation</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={counselling_icon} />
                    </div>
                    <p>Counselling</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={weight_icon} />
                    </div>
                    <p>Weight Loss Coaching</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={eating_icon} />
                    </div>
                    <p>Emotional Eating Coaching</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={life_icon} />
                    </div>
                    <p>Life Coaching</p>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <div className="icon">
                      <img alt="" src={promotion_icon} />
                    </div>
                    <p>Career Coaching</p>
                  </div>
                </div>
              </div>
              <br /> <br />
              <br />
            </div>
          </div>
        </section>
      </section>
    </Layout>
  )
}

export default Modalities
